import { connect } from 'react-redux';
import isEmpty from 'lodash/isEmpty';

import * as userSelectors from '../../../../selectors/user/userSelectors';
import * as checklistSelectors from '../../../../selectors/checklist/checklistSelectors';
import * as checklistV2Actions from '../../../../actions/ChecklistV2Actions';

import ChecklistAssignTaskButton from './ChecklistAssignTaskButton';

const mapStateToProps = (state) => {
  const taskId = checklistSelectors.getActiveTaskId(state);
  const partnerStatus = checklistSelectors.getActiveOrInvitedPartner(state);
  const currentUserId = userSelectors.getUserId(state);
  const partnerUserObjectId = userSelectors.getPartnerUserId(state);

  return {
    taskId,
    ownerFirstName: userSelectors.getOwnerFirstName(state),
    ownerObjectId: userSelectors.getOwnerAccountUserId(state),
    partnerFirstName: userSelectors.getPartnerFirstName(state),
    partnerUserObjectId,
    assignedToPartner: checklistSelectors.getIsTaskAssignedToPartnerAccount(state, taskId),
    assignedToOwner: checklistSelectors.getIsTaskAssignedToOwnerAccount(state, taskId),
    assignedToCurrentUser: checklistSelectors.getIsTaskAssignedToCurrentUser(state, taskId),
    activePartner: !isEmpty(partnerStatus) && partnerStatus.status === 'ACCEPTED_INVITE',
    isPartnerAccount: currentUserId === partnerUserObjectId,
  };
};

const mapDispatchToProps = dispatch => ({
  assignToPartner: (taskId, partnerUserObjectId, userObjectId) => dispatch(checklistV2Actions.assignPartnerToTask(taskId, partnerUserObjectId, userObjectId))
    .then(() => dispatch(checklistV2Actions.emitConfMsg())),
  handleNoPartnerClick: () => dispatch(checklistV2Actions.toggleInvitePartnerView()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ChecklistAssignTaskButton);



// WEBPACK FOOTER //
// ./src/components/manage/ChecklistV2/ChecklistAssignTaskButton/index.js